import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { HorizontalListData } from "common";
import { routerTransition } from "projects/backoffice/src/app/shared/animations/router.animations";
import { OfferDetailsData } from "./models/offer-details-data.model";
import { OfferDetailsAdapter } from "./offer-details.data";

@UntilDestroy()
@Component({
    selector: "ifb-offer-details",
    templateUrl: "./offer-details.component.html",
    providers: [OfferDetailsAdapter],
    animations: routerTransition,
    standalone: false
})
export class OfferDetailsComponent implements OnInit {
  data: OfferDetailsData;
  productListData: HorizontalListData[];

  constructor(
    private readonly route: ActivatedRoute,
    private readonly adapter: OfferDetailsAdapter
  ) { }

  ngOnInit(): void {
    this.route.data
      .pipe(untilDestroyed(this))
      .subscribe((data: OfferDetailsData) => {
        this.data = data;
        this.productListData = this.adapter.adaptProductListData(this.data);
      });
  }
}
